export const extractFileFromFormData = (formData: FormData): File | null => {
  for (const value of formData.values()) {
    if (value instanceof File) {
      return value
    }
  }
  return null
}

export const extractFormDataParams = (formData: FormData): Map<string, any> => {
  const params = new Map<string, any>()
  for (const [key, value] of formData.entries()) {
    if (!(value instanceof File)) {
      params.set(key, value)
    }
  }
  return params
}

export const getFileKeyFromFormData = (formData: FormData): string | null => {
  for (const [key, value] of formData.entries()) {
    if (value instanceof File) {
      return key
    }
  }
  return null
}
